// extracted by mini-css-extract-plugin
export default {"proinfo-box":"styles_proinfo-box__+YUQp"};